import { textChooser } from "../../util/textChooser"
import { Button } from "../controls/button"
import { Icon } from "../icons"
import './errorPage.scss';

export const ErrorPage = () => {

    const refreshPage = () => {
        window.location.reload()
    }

    return (
        <div className="error-page-wrapper">
            <div className="error-page-inner">
                <div className="error-icon">
                    <Icon type="alertPage"/>
                </div>
                
                <h1 className="error-page-title">
                    {textChooser("txt165")}
                </h1>
                
                <p className="error-page-desc">
                    {textChooser("txt166")}
                </p>

                <Button onClick={refreshPage} link>
                    {textChooser("txt167")}
                </Button>
            </div>
        </div>
    )
}